export default __webpack_public_path__ + "static/individualEnglishMoreCourseDetails-c836d5999985570181522f43a64aeaed.png";